/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form, Alert } from "react-bootstrap";
import { Information, Add, Trash } from "iconsax-react";
import { useParams, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import { sports, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { useMemberships } from "../../../../../hooks/useMemberships";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { conMotivo } from "../../../../components/Util/erroreServer";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";
import AvvisoFatturazione from '../../../../components/Util/AvvisoFatturazione';
import { segnalaMancanti } from '../../../../components/Util/campiMancanti';
import { CampoSport, sportDaSalvare, sportDelProdotto } from '../../../../components/Util/sportProdotto';

import chiediConferma from '../../../../components/Util/chiediConferma';
/*
 * Bozza di un corso singolo (una sola squadra, staff, impianto e orari decisi subito), con lo
 * stesso aspetto della scheda corso: un solo box a sezioni (Informazioni, Squadra,
 * Programmazione, Prezzi, Condizioni). Prima era un percorso a sei passi con un passo dedicato
 * ai conflitti: ora la disponibilita' si verifica dalla sezione Programmazione, e "Salva e
 * attiva" la verifica comunque prima di pubblicare (con conflitti il corso non si attiva).
 */

const GIORNI = [
    { value: 'MONDAY', label: 'Lunedì' },
    { value: 'TUESDAY', label: 'Martedì' },
    { value: 'WEDNESDAY', label: 'Mercoledì' },
    { value: 'THURSDAY', label: 'Giovedì' },
    { value: 'FRIDAY', label: 'Venerdì' },
    { value: 'SATURDAY', label: 'Sabato' },
    { value: 'SUNDAY', label: 'Domenica' }
];

export const CoursesEditClosed = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    const { profile: profileData } = useProfile({ autoFetch: true, includeTitles: true });
    const { getConfirmedMembers, memberships, loading: membershipsLoading } = useMemberships({ autoFetch: true });

    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profileData?.club?.profileStatus !== 'INACTIVE';
    // Prezzo standard e IVA bloccati come nel vecchio percorso: senza partita IVA o senza documenti fiscali validati
    const prezzoBloccato = sdiEnabledNoVat || billingNotConfirmed;
    const motivoBlocco = sdiEnabledNoVat
        ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
        : 'Prezzo standard e IVA modificabili dopo la validazione dei documenti fiscali';

    const [loadingShowed, setLoadingShowed] = useState(false);


    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

    const [pictureModalShowed, setPictureModalShowed] = useState(false);

    const [enabledSports, setEnabledSports] = useState([]);
    const [availableTeachers, setAvailableTeachers] = useState([]);
    const [availableFacilities, setAvailableFacilities] = useState([]);

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });

    // Esito dell'ultima verifica di disponibilita' (null = non ancora verificata)
    const [conflitti, setConflitti] = useState(null);
    const [verificaInCorso, setVerificaInCorso] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        name: '',
        sportTypes: [],
        teamName: '',
        maxMembers: 0,
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        newCoursePicture: '',
        coursePicture: '',
        description: '',
        status: 'DRAFT',
        type: 'CLOSED',
        coachId: '',
        venueId: '',
        startDate: '',
        endDate: '',
        weeklySchedule: []
    });

    usePageTitle(formData?.name ? `Bozza corso: ${formData.name}` : null);
    // Stato accanto al titolo: è una bozza (si attiva con «Salva e attiva»)
    useStatoNelTitolo({ bozza: true });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const token = JSON.parse(tokenDetailsString).idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const corso = await apiClient.getBookingCourseById(token, id);
                    setLoadingShowed(false);

                    if (corso) {
                        setFormData({
                            id: corso.id,
                            name: corso.name,
                            sportTypes: sportDelProdotto(corso),
                            teamName: corso.teamName,
                            maxMembers: corso.maxMembers || 0,
                            standard_price: corso.standard_price,
                            member_price: corso.member_price,
                            federated_price: corso.federated_price,
                            fitcoin_cashback: corso.fitcoin_cashback,
                            payable_in_club: corso.payable_in_club,
                            payable_stripe: corso.payable_stripe,
                            payable_bank: corso.payable_bank,
                            vat_rate: corso.vat_rate,
                            vat_nature: corso.vat_nature,
                            iva_5_percent: corso.iva_5_percent,
                            status: corso.status,
                            description: corso.description,
                            coursePicture: corso.coursePicture,
                            newCoursePicture: '',
                            type: 'CLOSED',
                            coachId: corso.coachId || '',
                            venueId: corso.venueId || '',
                            startDate: corso.startDate || '',
                            endDate: corso.endDate || '',
                            weeklySchedule: (corso.weeklySchedule || []).map((o, i) => ({ id: o.id || `${Date.now()}-${i}`, ...o }))
                        });
                    }
                }
            } catch (error) {
                setLoadingShowed(false);
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if (tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if (tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, [id]);

    useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }
    }, [profileData]);

    // Staff tecnico (membri COACH confermati) e impianti della struttura
    useEffect(() => {
        const carica = async () => {
            if (membershipsLoading || !memberships) return;
            try {
                const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
                if (!token) return;
                const apiClient = new MyApiClient();
                const [maestri, impianti] = await Promise.all([
                    Promise.resolve(getConfirmedMembers('COACH')),
                    apiClient.getVenues(token)
                ]);

                if (Array.isArray(maestri)) {
                    setAvailableTeachers(maestri.map(m => ({ value: m.userId, label: m.name, sportType: m.sport })));
                }
                const elenco = Array.isArray(impianti) ? impianti
                    : Array.isArray(impianti?.data) ? impianti.data
                    : Array.isArray(impianti?.venues) ? impianti.venues : [];
                setAvailableFacilities(elenco.map(v => ({ value: v.id, label: v.name, sportTypes: sportDelProdotto(v) })));
            } catch (error) {
                console.error('Error fetching teachers and facilities:', error);
            }
        };
        carica();
    }, [memberships, membershipsLoading, getConfirmedMembers]);

    // Staff e impianti che si possono scegliere: quelli di uno qualsiasi degli sport del corso
    const maestriDelloSport = availableTeachers.filter(t => formData.sportTypes.includes(t.sportType));
    const impiantiDelloSport = availableFacilities.filter(f => f.sportTypes.some(s => formData.sportTypes.includes(s)));

    // Ogni modifica a staff, impianto, date o orari rende vecchia l'ultima verifica
    const aggiorna = (modifiche, invalidaVerifica = false) => {
        setFormData(prev => ({ ...prev, ...modifiche }));
        if (invalidaVerifica) setConflitti(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        aggiorna({ [name]: value }, name === 'startDate' || name === 'endDate');
    };

    const cambiaSport = (elenco) => {
        // Staff e impianto dipendono dallo sport: se non sono di nessuno degli sport scelti vanno riscelti
        const coach = availableTeachers.find(t => t.value === formData.coachId);
        const venue = availableFacilities.find(f => f.value === formData.venueId);
        aggiorna({
            sportTypes: elenco,
            coachId: coach && elenco.includes(coach.sportType) ? formData.coachId : '',
            venueId: venue && venue.sportTypes.some(s => elenco.includes(s)) ? formData.venueId : '',
        }, true);
    };

    const aggiungiOrario = () => aggiorna({
        weeklySchedule: [...formData.weeklySchedule, { id: Date.now().toString(), dayOfWeek: '', startTime: '', endTime: '' }]
    }, true);

    const cambiaOrario = (index, campo, valore) => aggiorna({
        weeklySchedule: formData.weeklySchedule.map((o, i) => (i === index ? { ...o, [campo]: valore } : o))
    }, true);

    const rimuoviOrario = (index) => aggiorna({
        weeklySchedule: formData.weeklySchedule.filter((_, i) => i !== index)
    }, true);

    const mostraErrore = (titolo, testo) => {
        setModalTitle(titolo);
        setModalText(testo);
        setModalShowed(true);
    };

    // Quello che serve per verificare la disponibilita': l'elenco dei dati mancanti (vuoto se c'e' tutto)
    const mancantiPerVerifica = () => {
        const mancanti = [];
        if (!formData.sportTypes.length) mancanti.push({ campo: 'course-sport', messaggio: 'Manca la tipologia di sport' });
        if (!formData.coachId) mancanti.push({ campo: 'course-coachId', messaggio: 'Manca lo staff tecnico' });
        if (!formData.venueId) mancanti.push({ campo: 'course-venueId', messaggio: "Manca l'impianto" });
        if (!formData.startDate) mancanti.push({ campo: 'course-startDate', messaggio: 'Manca la data di inizio del corso' });
        if (!formData.endDate) mancanti.push({ campo: 'course-endDate', messaggio: 'Manca la data di fine del corso' });
        if (formData.startDate && formData.endDate && formData.endDate < formData.startDate) {
            mancanti.push({ campo: 'course-endDate', messaggio: 'La data di fine viene prima della data di inizio' });
        }
        if (formData.weeklySchedule.length === 0) {
            mancanti.push({ campo: 'course-aggiungi-orario', messaggio: 'Aggiungi almeno un orario settimanale' });
        }
        formData.weeklySchedule.forEach((o, i) => {
            if (!o.dayOfWeek) mancanti.push({ campo: `giorno-${i}`, messaggio: 'Manca il giorno' });
            if (!o.startTime) mancanti.push({ campo: `inizio-${i}`, messaggio: "Manca l'ora di inizio" });
            if (!o.endTime) mancanti.push({ campo: `fine-${i}`, messaggio: "Manca l'ora di fine" });
            if (o.startTime && o.endTime && o.endTime <= o.startTime) {
                mancanti.push({ campo: `fine-${i}`, messaggio: "L'ora di fine deve venire dopo l'ora di inizio" });
            }
        });
        return mancanti;
    };

    // Torna l'esito della verifica (con .conflitti = numero di sedute in conflitto) oppure null se non riuscita
    const verificaDisponibilita = async () => {
        if (segnalaMancanti(mancantiPerVerifica()) > 0) return null;
        try {
            setVerificaInCorso(true);
            const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
            const apiClient = new MyApiClient();
            const result = await apiClient.checkCourseConflicts(token, {
                startDate: formData.startDate,
                endDate: formData.endDate,
                weeklySchedule: formData.weeklySchedule,
                coachId: formData.coachId,
                venueId: formData.venueId,
                sport: formData.sportTypes[0]
            });
            if (!result || result.error) {
                mostraErrore("Errore", "Errore durante il controllo della disponibilità. Riprova.");
                return null;
            }
            const esito = { ...result, conflitti: result.summary?.conflictSlots || 0 };
            setConflitti(esito);
            return esito;
        } catch (error) {
            console.error('Errore nel controllo conflitti:', error);
            mostraErrore("Errore", "Errore durante il controllo della disponibilità. Riprova.");
            return null;
        } finally {
            setVerificaInCorso(false);
        }
    };

    // L'immagine viaggia come { content, name }: la si invia solo se ne e' stata
    // scelta una nuova, altrimenti si omette il campo (un content null oppure un
    // oggetto gia' incapsulato faceva fallire lo schema con "must be string").
    const preparePicturePayload = (payload, field) => {
        const current = payload[field];
        const content = typeof current === 'string' ? current : current?.content;
        if (content) {
            payload[field] = {
                content: content,
                name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
            };
        } else {
            delete payload[field];
        }
    };

    // Il corso come lo vuole il server, sempre in bozza: l'attivazione e' una chiamata a parte.
    const payloadBozza = () => {
        const tokenDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const payload = { ...formData, ...sportDaSalvare(formData.sportTypes), clubId: tokenDetails.localId, status: 'DRAFT' };

        if (!showingSociOptions) {
            payload.grants_club_membership = false;
            payload.member_price = payload.standard_price;
        }
        if (!showingTesseratiOptions) {
            payload.grants_federated_status = false;
            payload.federated_price = payload.standard_price;
        }

        preparePicturePayload(payload, 'newCoursePicture');
        Object.keys(payload).forEach(key => { if (payload[key] === '') delete payload[key]; });
        return payload;
    };

    const salvaBozza = async () => {
        if (!formData.name || formData.name.trim() === '') {
            segnalaMancanti([{ campo: 'course-name', messaggio: 'Manca il nome del corso' }]);
            return;
        }
        try {
            const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
            if (!token) return;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const result = await apiClient.updateBookingCourse(token, payloadBozza());
            setLoadingShowed(false);

            if (result && result.error) {
                mostraErrore("Errore durante l'operazione", result.error);
            } else {
                navigate('/struttura/booking/courses');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in salvaBozza: ' + error);
            mostraErrore("Errore durante l'operazione", conMotivo("Si è verificato un errore durante il salvataggio della bozza"));
        }
    };

    // Gli stessi controlli del vecchio percorso a passi, tutti insieme: ogni campo che manca viene segnalato sotto il campo stesso.
    const campiMancanti = () => {
        const numero = (v) => parseFloat(String(v ?? '').replace(',', '.'));
        const mancanti = [];
        if (!formData.name || !formData.name.trim()) mancanti.push({ campo: 'course-name', messaggio: 'Manca il nome del corso' });
        if (!formData.sportTypes.length) mancanti.push({ campo: 'course-sport', messaggio: 'Manca la tipologia di sport' });
        if (!formData.description || !String(formData.description).trim()) mancanti.push({ campo: 'course-description', messaggio: 'Manca la descrizione del corso' });
        if (!formData.newCoursePicture && !formData.coursePicture) mancanti.push({ campo: 'course-photo', messaggio: 'Manca la foto del corso' });
        if (!formData.teamName || !formData.teamName.trim()) mancanti.push({ campo: 'course-teamName', messaggio: 'Manca il nome della squadra' });
        if (!(parseInt(formData.maxMembers, 10) > 0)) mancanti.push({ campo: 'course-maxMembers', messaggio: 'I partecipanti massimi devono essere almeno 1' });
        mancantiPerVerifica().forEach((m) => { if (!mancanti.some(x => x.campo === m.campo)) mancanti.push(m); });
        if (!prezzoBloccato && !(numero(formData.standard_price) > 0)) mancanti.push({ campo: 'course-standard_price', messaggio: 'Il prezzo standard deve essere maggiore di 0' });
        if (showingTesseratiOptions && !(numero(formData.federated_price) > 0)) mancanti.push({ campo: 'course-federated_price', messaggio: 'Il prezzo tesserati / soci deve essere maggiore di 0' });
        if (!(numero(formData.fitcoin_cashback) >= 0)) mancanti.push({ campo: 'course-fitcoin_cashback', messaggio: 'Il cashback Fitcoin deve essere maggiore o uguale a 0' });
        if (!formData.payable_in_club && !formData.payable_stripe && !formData.payable_bank) {
            mancanti.push({ campo: 'switch-payable_in_club', messaggio: 'Attiva almeno una forma di pagamento: in struttura, Stripe o bonifico' });
        }
        return mancanti;
    };

    const salvaEAttiva = async () => {
        if (billingNotConfirmed) {
            mostraErrore("Documenti fiscali non ancora validati", "Non è possibile attivare la vendita di questo prodotto finché i documenti fiscali della tua struttura non sono stati validati. Per pubblicare prodotti e renderli acquistabili nell'App SportId Player devi prima configurare e confermare il metodo di fatturazione nella sezione La mia struttura → Documenti fiscali. Nel frattempo puoi continuare a creare prodotti e salvarli come bozza.");
            return;
        }
        if (segnalaMancanti(campiMancanti()) > 0) return;
        const esito = await verificaDisponibilita();
        if (!esito) return;
        if (esito.conflitti > 0) {
            mostraErrore("Orari non disponibili", `Ci sono ${esito.conflitti} sedute in conflitto con lo staff tecnico o con l'impianto: le trovi evidenziate nella sezione Programmazione. Cambia gli orari e riprova.`);
            return;
        }
        chiediConferma({ titolo: 'Attivare il corso?', testo: 'Il corso sarà visibile agli utenti che cercano la tua struttura sull\'app SportID.', conferma: 'Attiva', variante: 'primary' })
            .then((ok) => { if (ok) continuaSalvaEAttiva(); });
    };

    const continuaSalvaEAttiva = async () => {
        try {
            const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
            if (!token) return;
            const apiClient = new MyApiClient();
            const payload = payloadBozza();

            setLoadingShowed(true);
            const result = await apiClient.updateBookingCourse(token, payload);
            if (result && result.error) {
                setLoadingShowed(false);
                mostraErrore("Errore durante l'operazione", result.error);
                return;
            }

            const attivazione = await apiClient.changeCourseStatus(token, formData.id, 'PURCHASABLE');
            setLoadingShowed(false);

            if (attivazione && attivazione.error) {
                mostraErrore("Errore durante l'attivazione", attivazione.error);
            } else {
                navigate('/struttura/booking/courses');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in continuaSalvaEAttiva: ' + error);
            mostraErrore("Errore durante l'operazione", error?.response?.data?.detail || "Errore generico durante il salvataggio e attivazione");
        }
    };

    // Eliminazione della bozza: il backend la consente solo in stato DRAFT,
    // ed è proprio lo stato in cui si apre questa pagina.
    const eliminaBozza = async () => {
        if (await chiediConferma({ titolo: `Eliminare la bozza${formData.name ? ` «${formData.name}»` : ' del corso'}?`, testo: 'La bozza del corso sparisce dalla tua struttura.', conferma: 'Elimina' })) continuaEliminaBozza();
    };

    const continuaEliminaBozza = async () => {
        try {
            const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
            if (!token) return;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const result = await apiClient.deleteBookingCourse(token, id);
            setLoadingShowed(false);

            if (!result || result.error) {
                mostraErrore("Eliminazione non riuscita", result && result.error ? result.error : conMotivo("Si è verificato un errore durante l'eliminazione"));
            } else {
                navigate('/struttura/booking/courses');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in continuaEliminaBozza: ' + error);
            mostraErrore("Eliminazione non riuscita", conMotivo("Si è verificato un errore durante l'eliminazione"));
        }
    };

    const rimuoviFoto = () => setFormData(prev => ({ ...prev, newCoursePicture: '', coursePicture: '' }));

    const campoTesto = (fieldName, label, type = 'text', bloccato = false) => (
        <div title={bloccato ? motivoBlocco : undefined}>
            <Form.Label className="mb-2">{label}</Form.Label>
            {type === 'textarea' ? (
                <Form.Control as="textarea" rows={10} id={`course-${fieldName}`} className="mt-2" name={fieldName} value={formData[fieldName] || ''} onChange={handleChange} />
            ) : (
                <Form.Control
                    id={`course-${fieldName}`}
                    disabled={bloccato}
                    className={`mt-2${bloccato ? ' sid-ro-input' : ''}`}
                    type={type}
                    name={fieldName}
                    value={(formData[fieldName] || formData[fieldName] === 0) ? formData[fieldName] : ''}
                    onChange={handleChange}
                />
            )}
        </div>
    );

    const interruttore = (fieldName, label) => (
        <div className="sid-switch-row">
            <Form.Check
                type="switch"
                id={`switch-${fieldName}`}
                label={label}
                checked={!!formData[fieldName]}
                onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
            />
        </div>
    );

    const foto = formData.newCoursePicture
        ? `data:image/jpeg;base64,${formData.newCoursePicture}`
        : formData.coursePicture;

    const giorno = (valore) => GIORNI.find(g => g.value === valore)?.label || valore;

    return (
        <>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            <ProductImageUploader
                show={pictureModalShowed}
                onClose={() => setPictureModalShowed(false)}
                onSave={(base64String) => {
                    setPictureModalShowed(false);
                    setFormData(prev => ({ ...prev, newCoursePicture: base64String }));
                }}
                titolo="Immagine del corso"
            />

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            {billingNotConfirmed && (
                <AvvisoFatturazione />
            )}

            <Row className="align-items-start mt-0">
                <div className="col-xl-12">
                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey="informazioni">
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="informazioni">Informazioni generali</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Row className="align-items-start mt-4">
                                <div className="col-12">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="informazioni">
                                            <Card>
                                                <Card.Body className="sid-card-body--spaced">
                                                    <Row className="g-4">
                                                        <Col md={6}>
                                                            <Form.Label>Tipo</Form.Label>
                                                            <div className="sid-readonly-value">Singolo</div>
                                                        </Col>
                                                        <Col md={6}>
                                                            {campoTesto("name", "Nome corso *")}
                                                        </Col>
                                                        <Col md={6}>
                                                            <Form.Label className="mb-2">Tipologia di sport *</Form.Label>
                                                            <CampoSport
                                                                inputId="course-sport"
                                                                valore={formData.sportTypes}
                                                                onChange={cambiaSport}
                                                                opzioni={enabledSports}
                                                            />
                                                        </Col>
                                                        <Col md={12}>
                                                            {campoTesto("description", "Descrizione *", "textarea")}
                                                        </Col>
                                                        <Col md={12}>
                                                            <Form.Label>Foto *</Form.Label>
                                                            <div className="sid-photo-field">
                                                                <div className="sid-photo-field__preview">
                                                                    {foto ? <img src={foto} alt="" /> : <span>Nessuna foto</span>}
                                                                </div>
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    <Button id="course-photo" size="sm" variant="outline-dark" onClick={() => setPictureModalShowed(true)}>
                                                                        {foto ? 'Sostituisci foto' : 'Carica foto'}
                                                                    </Button>
                                                                    {foto && (
                                                                        <Button size="sm" variant="outline-danger" onClick={async () => { if (await chiediConferma({ titolo: 'Rimuovere la foto?', testo: 'La foto sparisce dal corso quando salvi.' })) rimuoviFoto(); }}>Rimuovi foto</Button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Squadra</h5>
                                                    <Row className="g-4">
                                                        <Col md={6}>
                                                            {campoTesto("teamName", "Nome della squadra *")}
                                                        </Col>
                                                        <Col md={3}>
                                                            {campoTesto("maxMembers", "Partecipanti massimi *", "number")}
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Programmazione</h5>
                                                    <Row className="g-4">
                                                        <Col md={6}>
                                                            <Form.Label className="mb-2">Staff tecnico *</Form.Label>
                                                            <Select
                                                                inputId="course-coachId"
                                                                className="mt-2"
                                                                styles={sidSelectStyles}
                                                                name="coachId"
                                                                value={maestriDelloSport.find(option => option.value === formData.coachId) || null}
                                                                onChange={(opzione) => aggiorna({ coachId: opzione?.value || '' }, true)}
                                                                options={maestriDelloSport}
                                                                isDisabled={!formData.sportTypes.length || maestriDelloSport.length === 0}
                                                                placeholder=""
                                                            />
                                                            {(!formData.sportTypes.length || maestriDelloSport.length === 0) && (
                                                                <Form.Text className="text-muted">
                                                                    {!formData.sportTypes.length ? 'Scegli prima la tipologia di sport.' : 'Nessun membro dello staff per questo sport.'}
                                                                </Form.Text>
                                                            )}
                                                        </Col>
                                                        <Col md={6}>
                                                            <Form.Label className="mb-2">Impianto *</Form.Label>
                                                            <Select
                                                                inputId="course-venueId"
                                                                className="mt-2"
                                                                styles={sidSelectStyles}
                                                                name="venueId"
                                                                value={impiantiDelloSport.find(option => option.value === formData.venueId) || null}
                                                                onChange={(opzione) => aggiorna({ venueId: opzione?.value || '' }, true)}
                                                                options={impiantiDelloSport}
                                                                isDisabled={!formData.sportTypes.length || impiantiDelloSport.length === 0}
                                                                placeholder=""
                                                            />
                                                            {(!formData.sportTypes.length || impiantiDelloSport.length === 0) && (
                                                                <Form.Text className="text-muted">
                                                                    {!formData.sportTypes.length ? 'Scegli prima la tipologia di sport.' : 'Nessun impianto per questo sport.'}
                                                                </Form.Text>
                                                            )}
                                                        </Col>
                                                        <Col md={3}>
                                                            {campoTesto("startDate", "Data inizio *", "date")}
                                                        </Col>
                                                        <Col md={3}>
                                                            {campoTesto("endDate", "Data fine *", "date")}
                                                        </Col>
                                                        <Col md={12}>
                                                            <Form.Label className="mb-2">Orari settimanali *</Form.Label>
                                                            {formData.weeklySchedule.length === 0 && (
                                                                <div className="sid-readonly-value mb-3">Nessun orario: aggiungine almeno uno.</div>
                                                            )}
                                                            {formData.weeklySchedule.map((orario, index) => (
                                                                <Row key={orario.id || index} className="g-3 mb-2 align-items-end">
                                                                    <Col md={4}>
                                                                        <Form.Label className="mb-1 small" htmlFor={`giorno-${index}`}>Giorno *</Form.Label>
                                                                        <Select
                                                                            inputId={`giorno-${index}`}
                                                                            styles={sidSelectStyles}
                                                                            value={GIORNI.find(g => g.value === orario.dayOfWeek) || null}
                                                                            onChange={(opzione) => cambiaOrario(index, 'dayOfWeek', opzione?.value || '')}
                                                                            options={GIORNI}
                                                                            placeholder=""
                                                                        />
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <Form.Label className="mb-1 small" htmlFor={`inizio-${index}`}>Ora inizio *</Form.Label>
                                                                        <Form.Control id={`inizio-${index}`} type="time" value={orario.startTime || ''} onChange={(e) => cambiaOrario(index, 'startTime', e.target.value)} />
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <Form.Label className="mb-1 small" htmlFor={`fine-${index}`}>Ora fine *</Form.Label>
                                                                        <Form.Control id={`fine-${index}`} type="time" value={orario.endTime || ''} onChange={(e) => cambiaOrario(index, 'endTime', e.target.value)} />
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <Button variant="outline-danger" size="sm" onClick={async () => { if (await chiediConferma({ titolo: 'Rimuovere l\'orario?', testo: 'L\'orario sparisce dalla programmazione settimanale.' })) rimuoviOrario(index); }} aria-label="Rimuovi orario">
                                                                            <Trash size="16" />
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            ))}
                                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                                <Button id="course-aggiungi-orario" variant="outline-dark" size="sm" onClick={aggiungiOrario}>
                                                                    <Add size="16" /> Aggiungi orario
                                                                </Button>
                                                                <Button variant="outline-dark" size="sm" onClick={verificaDisponibilita} disabled={verificaInCorso}>
                                                                    {verificaInCorso ? 'Verifica in corso…' : 'Verifica disponibilità'}
                                                                </Button>
                                                            </div>
                                                        </Col>

                                                        {conflitti && (
                                                            <Col md={12}>
                                                                <Alert variant={conflitti.conflitti > 0 ? 'warning' : 'success'} className="text-dark mb-3">
                                                                    {conflitti.conflitti > 0
                                                                        ? <strong>{conflitti.conflitti} sedute in conflitto su {conflitti.summary?.totalSlots ?? '?'}: cambia gli orari evidenziati.</strong>
                                                                        : <strong>Nessun conflitto: staff tecnico e impianto sono liberi in tutte le {conflitti.summary?.totalSlots ?? ''} sedute.</strong>}
                                                                </Alert>
                                                                {conflitti.conflitti > 0 && Array.isArray(conflitti.slots) && (
                                                                    <div className="table-responsive">
                                                                        <table className="sid-plan-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Data</th>
                                                                                    <th>Orario</th>
                                                                                    <th>Motivo</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {conflitti.slots.filter(s => !s.isValid).map((s, i) => {
                                                                                    const motivi = [];
                                                                                    if (s.venueConflict?.hasConflict) motivi.push(s.venueConflict.reason || 'Impianto occupato');
                                                                                    if (s.coachConflict?.hasConflict) motivi.push(s.coachConflict.reason || 'Staff tecnico occupato');
                                                                                    return (
                                                                                        <tr key={i}>
                                                                                            <td>
                                                                                                <div className="sid-plan-table__date">{s.date ? new Date(s.date).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '-'}</div>
                                                                                                <div className="sid-plan-table__day">{giorno(s.dayOfWeek)}</div>
                                                                                            </td>
                                                                                            <td>{s.startTime} - {s.endTime}</td>
                                                                                            <td>{motivi.join('; ') || 'Conflitto'}</td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        )}
                                                    </Row>

                                                    <h5 className="sid-form-section">Prezzi</h5>
                                                    <Row className="g-4">
                                                        <Col md={3}>
                                                            {campoTesto("standard_price", "Prezzo standard *", "number", prezzoBloccato)}
                                                        </Col>
                                                        <Col md={3}>
                                                            <div title={prezzoBloccato ? motivoBlocco : undefined}>
                                                                <Form.Label className="mb-2">IVA</Form.Label>
                                                                <Select
                                                                    className="mt-2"
                                                                    styles={sidSelectStyles}
                                                                    isDisabled={prezzoBloccato}
                                                                    name="vat_rate"
                                                                    value={findVatOption(formData)}
                                                                    onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                                                                    options={VAT_OPTIONS}
                                                                />
                                                            </div>
                                                        </Col>
                                                        {showingTesseratiOptions && (
                                                            <Col md={3}>
                                                                {campoTesto("federated_price", "Prezzo tesserati / soci *", "number")}
                                                            </Col>
                                                        )}
                                                        <Col md={3}>
                                                            {campoTesto("fitcoin_cashback", "Cashback Fitcoin *", "number")}
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Forme di pagamento</h5>
                                                    <div className="sid-switch-inline">
                                                        {interruttore("payable_in_club", "Acquisto pagabile in struttura")}
                                                        {paymentMethods.stripe_enabled && interruttore("payable_stripe", "Acquisto pagabile su Stripe")}
                                                        {paymentMethods.bank_transfer_enabled && interruttore("payable_bank", "Acquisto pagabile con bonifico")}
                                                    </div>
                                                </Card.Body>
                                            </Card>

                                            <div className="d-flex justify-content-between align-items-center gap-4 mt-4">
                                                <button type="button" onClick={() => eliminaBozza()} className="btn btn-danger light">Elimina bozza</button>
                                                <div className="d-flex gap-4">
                                                    <button type="button" className="btn btn-dark light" onClick={() => navigate('/struttura/booking/courses')}>Annulla</button>
                                                    <Button onClick={salvaBozza} className="btn btn-secondary">Salva bozza</Button>
                                                    <Button onClick={salvaEAttiva} className="btn btn-primary" disabled={verificaInCorso}>Salva e attiva</Button>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </Row>
        </>
    );
};
export default CoursesEditClosed;
